import { useId } from 'react';
import { LiksSwitch } from '../../../components/liks/LiksSwitch/LiksSwitch';
import { useI18n } from '../../../i18n/useI18n';
import { ChatbotSettingsCardFooter } from './ChatbotSettingsCardFooter';

type ChatbotPreviewToggleCardProps = {
  draftShowPreview: boolean;
  isDirty: boolean;
  discardLabel: string;
  saveLabel: string;
  onDraftChange: (value: boolean) => void;
  onDiscard: () => void;
  onSave: () => void;
};

export function ChatbotPreviewToggleCard({
  draftShowPreview,
  isDirty,
  discardLabel,
  saveLabel,
  onDraftChange,
  onDiscard,
  onSave,
}: ChatbotPreviewToggleCardProps) {
  const { translate } = useI18n();
  const previewSwitchId = useId();

  return (
    <div className="chatbot-settings__card">
      <div className="chatbot-settings__body">
        <h2 className="chatbot-settings__title">
          {translate('chatbots.settings.previewToggle.title')}
        </h2>

        <p className="chatbot-settings__cors-hint">
          {translate('chatbots.settings.previewToggle.description')}
        </p>

        <div className="chatbot-settings__switch-row">
          <LiksSwitch
            id={previewSwitchId}
            checked={draftShowPreview}
            aria-label={translate(
              'chatbots.settings.previewToggle.switchLabel',
            )}
            onChange={onDraftChange}
          />
          <label
            className="chatbot-settings__switch-label"
            htmlFor={previewSwitchId}
          >
            {translate('chatbots.settings.previewToggle.switchLabel')}
          </label>
        </div>
      </div>

      <ChatbotSettingsCardFooter
        isDirty={isDirty}
        isSaving={false}
        isSaveDisabled={!isDirty}
        discardLabel={discardLabel}
        saveLabel={saveLabel}
        onDiscard={onDiscard}
        onSave={onSave}
      />
    </div>
  );
}
